import {
	GET_PRODUCER,
  GET_PRODUCER_SUCCESS,
	GET_PRODUCER_FAIL
} from "./Constants"

const initialState = {
		isLoading: false,
		error: null,
		data: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case GET_PRODUCER:
			return {
				...state,
					isLoading: true
			}
		case GET_PRODUCER_SUCCESS:
			return {
				...state,
					isLoading: false,
					data: action.payload
			}
		case GET_PRODUCER_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}